let currentOutputEnergy = 0;
let currentInputEnergy = 0;
const outputListeners = new Set();
const inputListeners = new Set();

function clamp(value) {
  return Math.max(0, Math.min(1, Number(value) || 0));
}

export function publishVoiceOutputEnergy(value) {
  currentOutputEnergy = clamp(value);
  outputListeners.forEach((listener) => listener(currentOutputEnergy));
}

export function subscribeVoiceOutputEnergy(listener) {
  if (typeof listener !== 'function') return () => {};
  outputListeners.add(listener);
  listener(currentOutputEnergy);
  return () => outputListeners.delete(listener);
}

export function publishVoiceInputEnergy(value) {
  currentInputEnergy = clamp(value);
  inputListeners.forEach((listener) => listener(currentInputEnergy));
}

export function subscribeVoiceInputEnergy(listener) {
  if (typeof listener !== 'function') return () => {};
  inputListeners.add(listener);
  listener(currentInputEnergy);
  return () => inputListeners.delete(listener);
}
